module.exports = __webpack_public_path__ + "img/background.fbbeb4e6.png";